import { React, useState } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import PersonSearchRoundedIcon from '@mui/icons-material/PersonSearchRounded';
import RuleRoundedIcon from '@mui/icons-material/RuleRounded';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';
import { maskCpfCnpj } from '../../utils/maskCpfCnpj';

const CriarContrato = () => {
    const [cc, setCC] = useState('');
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitCriarContrato (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({
            cc,
            cpfCnpj
        });

        try {
            const response = await fetchFlask('criarContrato', body);
            setMessage(response.message);
            setStatus(response.status);
            setOpenAlerta(true);
            if (response.status === 'success') {
                setCC('');
                setCpfCnpj('');
            }
        } finally {
            setIsSubmit(false);
        }
    }

    const completedFields = [cc, cpfCnpj].filter(Boolean).length;

    return (
        <Box className='mainBox ui-workflow-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Criar Contrato Omie
            </PageHeader>

            <form action='' method='POST' id='formCriarContrato' onSubmit={submitCriarContrato} className='ui-workflow-layout'>
                <Box className='ui-workflow-workspace'>
                    <Box className='ui-workflow-intro'>
                        <Box>
                            <h2>Criação de contrato no Omie</h2>
                        </Box>
                    </Box>

                    <Box className='ui-workflow-panel'>
                        <Box className='ui-heading'>
                            <Inventory2RoundedIcon />
                            <Box>
                                <span>Etapa 1</span>
                                <strong>Conta contrato</strong>
                            </Box>
                        </Box>

                        <Box className='ui-input-strip'>
                            <ArticleRoundedIcon />
                            <TextField
                                required
                                label='Conta Contrato'
                                value={cc}
                                onChange={(e) => setCC(e.target.value)}
                            />
                        </Box>
                    </Box>

                    <Box className='ui-workflow-panel'>
                        <Box className='ui-heading'>
                            <PersonSearchRoundedIcon />
                            <Box>
                                <span>Etapa 2</span>
                                <strong>Documento do cliente</strong>
                            </Box>
                        </Box>

                        <Box className='ui-input-strip'>
                            <BadgeRoundedIcon />
                            <TextField
                                required
                                label='CPF ou CNPJ'
                                value={cpfCnpj}
                                onChange={(e) => setCpfCnpj(maskCpfCnpj(e.target.value))}
                            />
                        </Box>
                    </Box>
                </Box>

                <Box className='ui-workflow-summary'>
                    <Box className='ui-heading ui-heading-divided'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão do contrato</strong>
                        </Box>
                    </Box>

                    <Box className='ui-workflow-summary-list'>
                        <Box>
                            <span>Conta contrato</span>
                            <strong className={!cc ? 'is-empty' : undefined}>{cc || 'Não informada'}</strong>
                        </Box>
                        <Box>
                            <span>CPF ou CNPJ</span>
                            <strong className={!cpfCnpj ? 'is-empty' : undefined}>{cpfCnpj || 'Não informado'}</strong>
                        </Box>
                        <Box>
                            <span>Sistema destino</span>
                            <strong>Omie</strong>
                        </Box>
                    </Box>

                    <Box className='ui-attention'>
                        <RuleRoundedIcon />
                        <p>
                            Revise a conta contrato e o documento antes de criar o contrato no Omie.
                        </p>
                    </Box>

                    <Box className='ui-attention is-ok ui-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>{completedFields}/2 preenchidos</strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} startIcon={<ArticleRoundedIcon />}>
                        Criar Contrato
                    </SubmitButton>
                </Box>
            </form>
        </Box>
    );
};

export default CriarContrato;
